import React from 'react';
import css from './ShopSettingsForm.module.css';
import { isArrayLength } from '../../../util/genericHelpers';
import { Icons, ReviewRating } from '../../../components';
import { FormattedMessage } from 'react-intl';

const ReviewRatingSection = ({ reviews }) => {
  // Calculate average rating
  const totalRating =
    isArrayLength(reviews) && reviews.reduce((sum, review) => sum + review.attributes.rating, 0);
  const averageRating = isArrayLength(reviews) ? totalRating / reviews.length : 0;
  return (
    <div className={css.usernameSection}>
      {isArrayLength(reviews) ? (
        <ReviewRating
          rating={averageRating}
          className={css.desktopReviewRating}
          reviewStarClassName={css.reviewRatingStar}
        />
      ) : (
        <span className={css.feedback}>
          <FormattedMessage id="ShopSettingsForm.noFeedback" />
          <Icons name="questionCircle" />
        </span>
      )}
    </div>
  );
};

export default ReviewRatingSection;
